import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Pdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={3}
      d="M14.94 4c.762 0 2.415 1.263 1.738 3.972-.678 2.709-2.779 7.893-3.476 9.562-.697 1.67-2.347 5.387-3.609 7.49-1.262 2.102-3.815 3.824-5.103 2.528-1.288-1.295.125-3.145 2.372-4.378 2.247-1.232 5.146-2.285 8.077-3.13 2.931-.844 6.548-1.954 9.406-1.954 2.858 0 3.86 1.032 3.62 2.411-.239 1.379-1.65 1.76-3.375 1.379-1.725-.382-4.45-2.237-6.859-4.422-2.409-2.185-4.651-6.567-4.77-9.486C12.845 5.052 14.177 4 14.94 4z"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
